import React, { useEffect, useState } from 'react';
import { DASHBOARD_STYLES } from '../utils/dashboard';
import { injectDashboardStyles } from '../utils/dashboard/injectDashboardStyles';
import DashboardAuthGate from '../components/DashboardAuthGate';
import useDashboardCommandGate from '../hooks/useDashboardCommandGate';
import DashboardAuthenticated from './DashboardAuthenticated';

/**
 * 指挥页入口：仅做登录/口令门禁。
 * 验证通过后再挂载 DashboardAuthenticated，避免地图/WS/轮询在密码页拖死界面。
 * 工作区渲染统一走 Authenticated → builders → AuthedWorkspace → WorkspaceLayout → MapSideTools。
 */
function Dashboard() {
  // ZHXT_DASHBOARD_BUILD:2026-08-15-ortho-unified-v1
  if (typeof window !== 'undefined') {
    window.__ZHXT_DASHBOARD_BUILD = '2026-10-20-v3.4.0';
  }

  useEffect(() => {
    injectDashboardStyles(DASHBOARD_STYLES);
    window.dashboardLoadTime = Date.now();
    window.dashboardSettingsHydrated = false;
  }, []);

  const [isLoggedIn] = useState(() => !!localStorage.getItem('token'));
  const [authed, setAuthed] = useState(() => localStorage.getItem('command_authed') === '1');

  const {
    inputPwd,
    setInputPwd,
    pwdError,
    setPwdError,
    loadingPwd,
    verifying,
    checkPwd
  } = useDashboardCommandGate({ isLoggedIn, authed, setAuthed });

  if (!isLoggedIn) {
    return <DashboardAuthGate mode="login" />;
  }

  if (!authed) {
    return (
      <DashboardAuthGate
        mode="password"
        loadingPwd={loadingPwd}
        verifying={verifying}
        inputPwd={inputPwd}
        pwdError={pwdError}
        onInputPwdChange={(v) => {
          setInputPwd(v);
          setPwdError('');
        }}
        onCheckPwd={checkPwd}
      />
    );
  }

  return <DashboardAuthenticated />;
}

export default Dashboard;
